var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"title",attrs:{"cols":"10"}},[_vm._t("default")],2),_c('v-col',{attrs:{"cols":"2"}},[_c('img',{staticClass:"logo",attrs:{"src":"https://climate-rx.s3.us-west-1.amazonaws.com/logo.png","alt":"logo"}})]),_c('v-col',{attrs:{"cols":"12"}},[_c('hr')])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }